// extracted by mini-css-extract-plugin
export default {"download-certificate-button":"DownloadCertificateButton_download-certificate-button__YBamJ"};